module.exports = __webpack_public_path__ + "img/d65e087.jpg";